import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useScroll, useSpring, useTransform } from "framer-motion";

import MobileMenu from "./components/MobileMenu";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StorySection from "./components/StorySection";
import ExperienceSection from "./components/ExperienceSection";
import EventsSection from "./components/EventsSection";
import GallerySection from "./components/GallerySection";
import QuoteSection from "./components/QuoteSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ReservationModal from "./components/ReservationModal";
import MenuPage from "./pages/MenuPage";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [reserveOpen, setReserveOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [cursor, setCursor] = useState({ x: 0, y: 0 });

  const navigate = useNavigate();
  const location = useLocation();

  const { scrollYProgress } = useScroll();
  useSpring(scrollYProgress, { stiffness: 100, damping: 30 });
  const heroY = useTransform(scrollYProgress, [0, 0.35], [0, 150]);
  const heroScale = useTransform(scrollYProgress, [0, 0.35], [1.08, 1]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onMove = (e) => setCursor({ x: e.clientX, y: e.clientY });
    window.addEventListener("scroll", onScroll);
    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    if (id === "menu") {
      navigate("/menu");
      return;
    }

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="app">
      <div className="cursor-glow" style={{ left: cursor.x, top: cursor.y }} />

      <MobileMenu
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        setReserveOpen={setReserveOpen}
        scrollTo={scrollTo}
      />

      {/* Render Navbar on all pages except MenuPage */}
      {location.pathname !== "/menu" && (
        <Navbar
          scrolled={scrolled}
          scrollTo={scrollTo}
          setReserveOpen={setReserveOpen}
          setMenuOpen={setMenuOpen}
        />
      )}

      <Routes>
        <Route
          path="/"
          element={
            <main>
              <HeroSection
                heroY={heroY}
                heroScale={heroScale}
                setReserveOpen={setReserveOpen}
                scrollTo={scrollTo}
              />
              <StorySection scrollTo={scrollTo} />
              {/* MenuSection removed from main page as requested */}
              <ExperienceSection setReserveOpen={setReserveOpen} />
              <EventsSection setReserveOpen={setReserveOpen} />
              <GallerySection />
              <QuoteSection />
              <ContactSection setReserveOpen={setReserveOpen} />
            </main>
          }
        />
        <Route
          path="/menu"
          element={<MenuPage setReserveOpen={setReserveOpen} />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer scrollTo={scrollTo} setReserveOpen={setReserveOpen} />

      <ReservationModal
        reserveOpen={reserveOpen}
        setReserveOpen={setReserveOpen}
      />
    </div>
  );
}

export default App;